import { ArrowDownThickIcon } from './ArrowDownThickIcon';

/**
 * author: Austin Andrews
 * id E345145F-AD51-4B6F-8F7B-EC22C34E4E89
 * name arrow-down-thick
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-down-thick.svg
 * tags
 * - Arrow 
 */
export const ArrowBottomThickIcon = ArrowDownThickIcon;
export default ArrowBottomThickIcon